import { contactMessage } from '../api/contact.service.js'
export default {
  state:{
      contact:{}
  },
  getters: {
    
  },
  mutations: {
    contactMessage(state, newcontact){
        state.contact = newcontact
      },
  },
  actions: {
   
    async contactMessage(context, cntact) {
      console.log("je suis dans le store  contact message")
      let contact = await contactMessage(cntact)
      context.commit('contactMessage', contact)
    },


  }
}


// WEBPACK FOOTER //
// ./src/store/contact.store.js